import axios from "axios";

export const handleApiError = (error) => {
	if (error.response) {
		const { status, data } = error.response;

		if (status === 404 && data?.response?.message?.[0]?.includes("does not exist")) {
			return `Instância não existe: ${data.response.message[0]}`;
		}

		if (status === 400 && data?.response?.message?.[0]?.includes("disconnected")) {
			return `Instância desconectada: ${data.response.message[0]}`;
		}

		if (status === 401) {
			return "Não autorizado: verifique sua API Key.";
		}

		return `Erro ${status}: ${data?.error || "Erro desconhecido."}`;
	}

	if (error.message) {
		return `Erro: ${error.message}`;
	}

	return "Ocorreu um erro desconhecido.";
};

// 1️⃣ Enviar mensagem
export const sendMessage = async (url, apiKey, instance, phone, message) => {
	try {
		const response = await axios.post(
			`https://${url}/message/sendText/${instance}`,
			{
				number: `55${phone}`,
				text: message,
				delay: 0,
				linkPreview: true,

				// 🔽 V2: menções e reply (quote) FICAM AQUI, no topo do body
				// mentionsEveryOne: false,
				// mentioned: [
				// 	"5516999999999@s.whatsapp.net", // JID completo é o mais confiável
				// ],
				quoted: {
					key: { id: "AppSZ" },
					message: { conversation: "Conteúdo da mensagem original (opcional)" },
				},
			},
			{
				headers: {
					apikey: apiKey,
					"Content-Type": "application/json",
				},
			}
		);

		return response.data;
	} catch (error) {
		const friendlyMessage = handleApiError(error);
		console.error("Erro ao enviar mensagem:", friendlyMessage);
		throw new Error(friendlyMessage);
	}
};

export const sendImageMessage = async (url, apiKey, instance, phone, imageUrl, caption = "") => {
	try {
		const response = await axios.post(
			`https://${url}/message/sendMedia/${instance}`,
			{
				number: `55${phone}`,
				mediatype: "image", // image, video or document
				mimetype: "image/jpeg",
				caption: caption,
				media: imageUrl /* url or base64 */,
				fileName: "Imagem.jpeg",
				quoted: {
					key: { id: "AppSZ" },
					message: { conversation: "Conteúdo da mensagem original (opcional)" },
				},
			},
			{
				headers: {
					apikey: apiKey,
					"Content-Type": "application/json",
				},
			}
		);
		return response.data;
	} catch (error) {
		const friendlyMessage = handleApiError(error);
		console.error("Erro ao enviar imagem:", friendlyMessage);
		throw new Error(friendlyMessage);
	}
};

// 2️⃣ Verificar status da instância
export const getStatus = async (url, apiKey, instance) => {
	try {
		const response = await axios.get(`https://${url}/instance/connectionState/${instance}`, {
			headers: {
				apikey: apiKey,
				"Content-Type": "application/json",
			},
		});

		return response.data;
	} catch (error) {
		const friendlyMessage = handleApiError(error);
		console.error("Erro ao verificar status:", friendlyMessage);
		throw new Error(friendlyMessage);
	}
};

// 2️⃣ Gerar QrCode
export const connectionInstance = async (url, apiKey, instance) => {
	try {
		const response = await axios.get(`https://${url}/instance/connect/${instance}`, {
			instanceName: instance,
			headers: {
				apikey: apiKey, // 🔑 Header obrigatório
			},
		});

		return response.data; // pairingCode, code, count
	} catch (error) {
		console.error("Erro ao conectar instância:", error);
		throw error;
	}
};

// 3️⃣ Criar nova instância
export const createInstance = async (url, apiKey, instanceName) => {
	try {
		const response = await axios.post(
			`https://${url}/instance/create`,
			{
				instanceName,
				integration: "WHATSAPP-BAILEYS", // ou "WHATSAPP-BUSINESS" conforme seu caso
				qrcode: true, // já retorna QR code automaticamente
				groupsIgnore: true,
			},
			{
				headers: {
					apikey: apiKey,
					"Content-Type": "application/json",
				},
			}
		);

		return response.data;
	} catch (error) {
		console.error("❌ Erro bruto:", error.response?.data || error.message);
		const friendlyMessage = handleApiError(error);
		throw new Error(friendlyMessage);
	}
};

// 🔍 Verifica se a instância já existe pelo nome
export const fetchInstanceByName = async (url, apiKey, instanceName) => {
	try {
		const response = await axios.get(`https://${url}/instance/fetchInstances`, {
			params: {
				instanceName,
			},
			headers: {
				apikey: apiKey,
			},
		});

		return response.data; // deve retornar a instância ou um array
	} catch (error) {
		console.error("❌ Erro ao buscar instância:", error.response?.data || error.message);
		throw new Error("Erro ao buscar instância");
	}
};

// export const createInstance = async (url, apiKey, instanceName) => {
// 	try {
// 		const response = await axios.post(
// 			`https://${url}/instance/create`,
// 			{ instanceName },
// 			{
// 				headers: {
// 					apikey: apiKey,
// 					"Content-Type": "application/json",
// 				},
// 			}
// 		);
// 		return response.data;
// 	} catch (error) {
// 		const friendlyMessage = handleApiError(error);
// 		console.error("Erro ao criar instância:", friendlyMessage);
// 		throw new Error(friendlyMessage);
// 	}
// };

// // 4️⃣ Obter QR Code para pareamento
// export const getQrCode = async (url, apiKey, instance) => {
// 	try {
// 		const response = await axios.get(`https://${url}/instance/qr/${instance}`, {
// 			headers: {
// 				apikey: apiKey,
// 				"Content-Type": "application/json",
// 			},
// 		});
// 		return response.data;
// 	} catch (error) {
// 		const friendlyMessage = handleApiError(error);
// 		console.error("Erro ao obter QR Code:", friendlyMessage);
// 		throw new Error(friendlyMessage);
// 	}
// };

// 5️⃣ Deletar instância
export const deleteInstance = async (url, apiKey, instance) => {
	try {
		const response = await axios.delete(`https://${url}/instance/delete/${instance}`, {
			headers: {
				apikey: apiKey,
				"Content-Type": "application/json",
			},
		});
		return response.data;
	} catch (error) {
		const friendlyMessage = handleApiError(error);
		console.error("Erro ao deletar instância:", friendlyMessage);
		throw new Error(friendlyMessage);
	}
};
